import styled from "styled-components";
import { getHexOpacity } from "../../../../../../../utils/pipes";

export const PathologyItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  background-color: ${({active}) => active ? "#6C6BF5" : "#F0F0FF"};  
  border-radius: 14px;
  margin-bottom: 10px;
  cursor: pointer;
  .device-addition-icon {
    font-size: 20px;
    color: ${({active}) => active ? "#FFFFFF" : "#6C6BF5"};
    margin-right: 5px;
  }
  .device-info {
    color: ${({active}) => active ? "#FFFFFF" : "#1F1F52"};
    &__name {
      font-size: 18px;
    }
  }
`